<template>
    <div class="header">

    </div>
</template>

<script>

export default {
    data() {
        return {

        }
    }
}
</script>

<style scoped>
    .header {
        background-color: #979696;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 10%;
    }
</style>
